import {RefObject} from 'react';

export type useTextWidthTextOptions = {
  text: string | string[] | undefined;
  font?: string;
};

export type useTextWidthRefOptions = {
  ref: RefObject<Element>;
};

export interface useTextWidthType {
  (options: useTextWidthTextOptions | useTextWidthRefOptions): number;
}

const getContext = () => {
  const fragment: DocumentFragment = document.createDocumentFragment();
  const canvas: HTMLCanvasElement = document.createElement('canvas');
  fragment.appendChild(canvas);
  return canvas.getContext('2d') as CanvasRenderingContext2D;
};

export const getIntrinsicTextWidth = (ref: RefObject<Element>): number | undefined => {
  if (ref.current?.textContent) {
    const context = getContext();
    const computedStyles = window.getComputedStyle(ref.current);
    context.font = computedStyles.font;
    const metrics = context.measureText(ref.current.textContent);

    return metrics.width;
  } else if (ref.current && (ref as RefObject<HTMLInputElement>)?.current?.value) {
    const textContent = (ref as RefObject<HTMLInputElement>)?.current?.value

    if (!textContent) return

    const context = getContext();
    const computedStyles = window.getComputedStyle(ref.current);
    context.font = computedStyles.font;
    const metrics = context.measureText(textContent);

    return metrics.width;
  }
}